import {FormConfig} from '../../../models/form-config';
import {FieldType} from '../../../models/field-type';
import {CessionSectionConsts} from './cession-section.consts';
import {SelectContentText} from '../../../components/fields/multiselect/material-multiselect.component';
import {
  CessionStateService
} from '../../../../core/services/impl/section-services/cession-service/cession-state.service';
import {BehaviorSubject} from 'rxjs/Rx';
import {Validator} from '../../../models/validator.enum';
import {isNext} from '../../../../core/utils/utils';
import {RegExpKey, RegExpService} from '../../../services/reg-exp.service';

export class CessionSectionConfig {

  isNext: boolean = isNext();
  consts = CessionSectionConsts;

  createCessionConfig(stateService: CessionStateService,
                      regExpService: RegExpService): FormConfig {
    return <FormConfig> {
      formKey: 'CESSION_SECTION',
      fieldsConfig: [{
        caption: `CESSION_SECTION.FORM_FIELDS.IS_CESSION.isCession`,
        fieldKey: this.consts.IS_CESSION,
        type: this.isNext ? FieldType.ButtonToggle : FieldType.Radio,
        description: 'CESSION_SECTION.FORM_FIELDS.IS_CESSION.description',
        radioConfig: [
          {value: true, label: 'yes'},
          {value: false, label: 'no'},
        ],
        validators: [Validator.REQUIRED]
      },
        {
          fieldKey: this.consts.BANK_ID,
          caption: 'CESSION_SECTION.FORM_FIELDS.bankId',
          type: FieldType.Select,
          validators: [Validator.REQUIRED],
          options: {
            item: 'id',
            label: {label: 'name'},
            items: stateService.bankItems,
          },
          select: {
            contentTextType: SelectContentText.CAPTION_TEXT,
            dropdownPosition: 'bottom',
            multiple: false,
            searchable: true,
            loadingEvent: new BehaviorSubject(null),
            setValueIfOnlyOneItem: true,
          }
        },
        {
          fieldKey: this.consts.AMOUNT,
          caption: 'CESSION_SECTION.FORM_FIELDS.amount',
          type: FieldType.TextField,
          validators: [Validator.REQUIRED_NOT_BLANK],
          properties: {
            textTransform: {
              type: 'amount'
            },
          }
        },
        {
          fieldKey: this.consts.POSTAL_CODE,
          caption: 'CESSION_SECTION.FORM_FIELDS.postalCode',
          type: FieldType.TextField,
          validators: [
            Validator.REQUIRED_NOT_BLANK,
            Validator.POSTAL_CODE,
            {
              name: Validator.PATTERN,
              pattern: regExpService.getRegExp(RegExpKey.POSTAL_CODE)
            }],
          maskConfig: {
            mask: '00-000',
            dropSpecialCharacters: false
          },
          autocomplete: 'postal-code',
          properties: {
            mobileInputType: 'tel',
          }
        }]
    }
  }
}
